module.exports = __webpack_public_path__ + "static/media/LoginForm_sideImage.e895348b.jpg";